import { render, staticRenderFns } from "./GlobalPopup.vue?vue&type=template&id=4e80117e"
import script from "./GlobalPopup.vue?vue&type=script&lang=js"
export * from "./GlobalPopup.vue?vue&type=script&lang=js"
import style0 from "./GlobalPopup.vue?vue&type=style&index=0&id=4e80117e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports